// Inbox = die uncategorisierten Notes. Spec §10: „landet in Inbox"
import { Navigate } from "react-router-dom";

export default function InboxPage() {
  // Redirect zu /n mit Filter "ohne Kategorie" — die Notes-Page ist klüger.
  // Für jetzt: einfacher Redirect zu /n (alias-route fuer /notes der via
  // openresty-Proxy nicht zur React-App geht).
  return <Navigate to="/n" replace />;
}
